import { getBoolean, getNumber, getString } from "firebase/remote-config"

import { remoteConfig } from "@firebaseConfig/clientApp"

export const getRemoteConfigValue = (key: string): string => {
  return getString(remoteConfig, key)
}

export const getRemoteConfigBoolean = (key: string): boolean => {
  return getBoolean(remoteConfig, key)
}

export const getRemoteConfigNumber = (key: string): number => {
  return getNumber(remoteConfig, key)
}
